import { ngRoute } from '../../../../app/routing/ngRoute';
import { Capability } from '@splunk/olly-services/lib/services/CurrentUser/Capabilities';

export default [
    '$scope',
    '$log',
    'signalboost',
    'signalviewMetrics',
    'config',
    '$location',
    'featureEnabled',
    'PRODUCT_NAME',
    'organizationService',
    'hasCapability',
    function (
        $scope,
        $log,
        signalboost,
        signalviewMetrics,
        config,
        $location,
        featureEnabled,
        PRODUCT_NAME,
        organizationService,
        hasCapability
    ) {
        $scope.PRODUCT_NAME = PRODUCT_NAME;

        if (ngRoute.params.tab === 'integrations') {
            $location.path('/integrations');
            return;
        }
        $scope.hasInfraEntitlement = featureEnabled('infra');

        $scope.tabs = ['Members', 'Billing', 'AccessTokens'];

        // scope bound functions
        $scope.showUnreleasedFeatures = config('superpower.unreleasedFeatures');
        $scope.initialized = false;

        $scope.editable = false;
        $scope.organizationSettingsEditable = false;

        initOrg();

        signalviewMetrics.endRouteUi('organization');

        function failClosedOnPermissionLookupError(permissionName) {
            return function (error) {
                $log.log(`Failed looking up user auth org permission: ${permissionName}.`, error);
                return false;
            };
        }

        function getOrgEditable() {
            $scope.editable = false;
            $scope.organizationSettingsEditable = false;
            return organizationService
                .get()
                .then((org) => {
                    $scope.org = org;
                    return Promise.all([
                        signalboost.uauth
                            .canCreate(org.id, 'OrgUser')
                            .catch(failClosedOnPermissionLookupError('OrgUser create')),
                        hasCapability(Capability.UPDATE_ORGANIZATION).catch(
                            failClosedOnPermissionLookupError(Capability.UPDATE_ORGANIZATION)
                        ),
                    ]);
                })
                .then(([hasOrgUserCreatePermission, hasUpdateOrganizationCapability]) => {
                    $scope.editable = hasOrgUserCreatePermission;
                    $scope.organizationSettingsEditable = featureEnabled('newRbacExperience')
                        ? hasUpdateOrganizationCapability
                        : hasOrgUserCreatePermission;
                })
                .catch(function (error) {
                    $log.log('Failed looking up user auth org permissions.', error);
                    return false;
                });
        }

        function initOrg() {
            getOrgEditable().then(() => {
                $scope.initialized = true;
            });
        }
    },
];
